<div class="store-success" *ngIf="open">
  <div class="store-success__overlay" aria-hidden="true"></div>

  <section #panel class="store-success__panel" role="dialog" aria-modal="true"
    aria-labelledby="storeSuccessTitle">
    <div class="store-success__check" aria-hidden="true">&#10003;</div>

    <h2 class="store-success__title" id="storeSuccessTitle">
      {{ 'clicStore.exchangeDoneTitle' | translate }}
    </h2>
    <p class="store-success__lead">{{ 'clicStore.exchangeDoneLead' | translate }}</p>

    <ul class="store-success__items">
      <li *ngFor="let item of items">
        <span class="store-success__qty">{{ item.quantity }}&times;</span>
        <span class="store-success__item-name">{{ item.name }}</span>
      </li>
    </ul>

    <dl class="store-success__summary">
      <div class="store-success__row">
        <dt>{{ 'clicStore.pointsSpent' | translate }}</dt>
        <dd class="store-success__debit">
          &minus;{{ pointsSpent | number }} {{ 'clicStore.pointsUnit' | translate }}
        </dd>
      </div>
      <div class="store-success__row store-success__row--strong">
        <dt>{{ 'clicStore.newBalance' | translate }}</dt>
        <dd>
          <ng-container *ngIf="!balanceLoading && !balanceUnknown; else loadingBalance">
            {{ newBalance | number }} {{ 'clicStore.pointsUnit' | translate }}
          </ng-container>
        </dd>
      </div>
    </dl>

    <p class="store-success__protocol" *ngIf="protocol">
      {{ 'clicStore.protocol' | translate }}: <strong>{{ protocol }}</strong>
    </p>

    <p class="store-success__note">{{ 'clicStore.exchangeDoneNote' | translate }}</p>

    <div class="store-success__actions">
      <button #primary type="button" class="store-success__primary" (click)="backToStore.emit()">
        {{ 'clicStore.keepShopping' | translate }}
      </button>
      <button type="button" class="store-success__secondary" (click)="goToStatement.emit()">
        {{ 'clicStore.checkStatement' | translate }}
      </button>
    </div>
  </section>
</div>

<ng-template #loadingBalance>
  <span class="store-success__muted">
    {{ (balanceUnknown ? 'clicStore.balanceUnavailable' : 'clicStore.loading') | translate }}
  </span>
</ng-template>
